export default __webpack_public_path__ + "images/quote-purple.png";